import {
  SPECIE,
  SECTIONS,
  PERMISSIONS,
  ACTION_TYPES
} from 'utils/constantPermissions'

export class CUARENTENAS {
  static VISUALIZAR = [
    {
      specie: SPECIE.Pavos,
      section: SECTIONS.Cuarentenas,
      permission: PERMISSIONS['Instalaciones en cuarentena'],
      actionType: [ACTION_TYPES.Visualizar]
    }
  ]

  static CREAR = [
    {
      specie: SPECIE.Pavos,
      section: SECTIONS.Cuarentenas,
      permission: PERMISSIONS['Instalaciones en cuarentena'],
      actionType: [ACTION_TYPES.Crear]
    }
  ]

  static MANTENEDOR_VISUALIZAR = [
    {
      specie: SPECIE.Pollos,
      section: SECTIONS.Cuarentenas,
      permission: PERMISSIONS['Instalaciones en cuarentena'],
      actionType: [ACTION_TYPES.Visualizar]
    }
  ]

  static MANTENEDOR_CREAR = [
    {
      specie: SPECIE.Pollos,
      section: SECTIONS.Cuarentenas,
      permission: PERMISSIONS['Instalaciones en cuarentena'],
      actionType: [ACTION_TYPES.Crear]
    }
  ]

  static MANTENEDOR_EDITAR = [
    {
      specie: SPECIE.Pollos,
      section: SECTIONS.Cuarentenas,
      permission: PERMISSIONS['Instalaciones en cuarentena'],
      actionType: [ACTION_TYPES.Editar]
    }
  ]

  static MANTENEDOR_ESTADO = [
    {
      specie: SPECIE.Pollos,
      section: SECTIONS.Cuarentenas,
      permission: PERMISSIONS['Instalaciones en cuarentena'],
      actionType: [ACTION_TYPES['Activar/Desactivar']]
    }
  ]
}
